import { Injectable } from '@angular/core';
import { Subject }    from 'rxjs';
import { Segment } from "../../components/ngx-json-viewer/ngx-json-viewer";

/*
  Generated class for the NgxJsonViewerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NgxJsonViewerProvider {

    // Observable string sources
    private segmentSelectedSource = new Subject<Segment>();
    private segmentExpandedSource = new Subject<Segment>();
    private segmentCollapedSource = new Subject<Segment>();
   
    // Observable string streams
    segmentSelected$ = this.segmentSelectedSource.asObservable();
    segmentExpanded$ = this.segmentExpandedSource.asObservable();
    segmentCollaped$ = this.segmentCollapedSource.asObservable();
   
    // Service message commands
    selectSegment(segment: Segment) {
      this.segmentSelectedSource.next(segment);
    }
    expandSegment(segment: Segment) {
        this.segmentExpandedSource.next(segment);
      }
    collapseSegment(segment: Segment) {
        this.segmentCollapedSource.next(segment);
      }
}



// WEBPACK FOOTER //
// ./src/providers/ngx-json-viewer/ngx-json-viewer.ts